import { get } from './index.js';

/**
 * Low-level API call for Algolia keys.
 *
 * Notes:
 * - Keep this function focused on the network request + basic validation.
 * - Caching, refresh scheduling, and retries are handled by the Algolia keys manager/service.
 */
export const fetchAlgoliaKeys = async () => {
  try {
    const response = await get(`/v2/algolia-api-keys`);
    if (!response.ok) throw new Error('Failed to fetch Algolia API keys');

    const { algoliaKeys: responseKeys } = response.body || {};
    if (!responseKeys?.appId || !responseKeys?.searchApiKey) throw new Error('Missing Algolia API keys');

    return responseKeys;
  } catch (error) {
    // Log error but return null so manager can retry
    console.error('Error fetching Algolia keys:', error);
    return null;
  }
};
